import assert from 'minimalistic-assert';
import createAdapterDependencies from './adapters.js';
import createAtomDependencies from './atoms.js';
import createConfigDependencies from './configs.js';
import createModuleDependencies from './modules.js';
const adapterKeys = [
    'createLogger',
    'legacyPrivToPub',
    'seedStorage',
    'unsafeStorage',
    'fetch',
    'freeze',
];
const createDependencies = ({ adapters, config }) => {
    assert(config, 'expected config object');
    adapterKeys.forEach((key) => assert(adapters[key], `expected adapter "${key}"`));
    const logger = adapters.createLogger('passkeys');
    const configs = createConfigDependencies({ config });
    const modules = createModuleDependencies();
    const atoms = createAtomDependencies();
    const adaptersTree = createAdapterDependencies({ adapters });
    return [
        ...adaptersTree,
        ...configs,
        ...modules,
        ...atoms,
        {
            definition: { id: 'logger', type: 'module', factory: () => logger },
        },
    ];
};
export default createDependencies;
